/**
 * Korte tijdsaanduiding voor een melding: vandaag enkel het uur, dit jaar "8 okt", anders "8 okt 2025".
 */
export function formatNotificationTime(date: Date, locale: string = "nl-BE"): string {
	locale = locale || "nl-BE";
	let now = new Date();
	let sameDay = date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate();
	if (sameDay) {
		return date.toLocaleTimeString(locale, {hour: "2-digit", minute: "2-digit"});
	}
	if (date.getFullYear() == now.getFullYear()) {
		return date.toLocaleDateString(locale, {day: "numeric", month: "short"}).replace(".", "");
	}
	return date.toLocaleDateString(locale, {day: "numeric", month: "short", year: "numeric"}).replace(".", "");
}

export type NotificationGroupKey = "today" | "older" | string;

/**
 * Groep van een melding in de lijst: "today", de maandnaam voor deze en vorige maand, anders "older".
 */
export function getNotificationGroup(date: Date, locale: string = "nl-BE"): {key: NotificationGroupKey, label: string} {
	locale = locale || "nl-BE";
	let now = new Date();
	let sameDay = date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate();
	if (sameDay) return {key: "today", label: ""};
	let monthIndex = date.getFullYear() * 12 + date.getMonth();
	let nowIndex = now.getFullYear() * 12 + now.getMonth();
	if (nowIndex - monthIndex <= 1 && monthIndex <= nowIndex) {
		let label = date.toLocaleDateString(locale, {month: "long"});
		return {key: `month-${monthIndex}`, label};
	}
	return {key: "older", label: ""};
}
